import React, { useState } from "react";
import "./WinGoModal.css";
import Winner_Modal from "../Winner_Modal/Winner_Modal";
import Looser_Modal from "../Looser_Modal/Looser_Modal";
import Successfull_strip_modal from "../Successfull_strip_modal/Successfull_strip_modal";
import { useDispatch } from "react-redux";
import { GetAllHistory, PlaceBet } from "../../../../../features/games/color_prediction/Slice";
import { useSocket } from "../../../../../utils/socket";
import { GETAuthLogin } from "../../../../../features/auth/Slice";

const BET_CUTOFF = 10;
const WinGoModal = ({ mainActiveTab, bet_type, selectedValue, type, onClose, multiply }) => {
  const dispatch = useDispatch();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [showWinner, setShowWinner] = useState(false);
  const [showLooser, setShowLooser] = useState(false);
  const [betError, setBetError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [agreed, setAgreed] = useState(true);

  const [balance, setBalance] = useState(10);
  const [multiplier, setMultiplier] = useState(multiply ?? "1");
  const [quantity, setQuantity] = useState(1);

  const totalAmount = (balance * quantity * Number(multiplier)).toFixed(2);

  const themeColors = {
    red_violet:
      "linear-gradient(158deg, rgba(234,4,2,1) 0%, rgba(234,4,2,1) 33%, rgba(140,51,207,1) 69%, rgba(140,51,207,1) 100%)",
    green_violet:
      "linear-gradient(158deg, rgba(68,168,65,1) 0%, rgba(68,168,65,1) 33%, rgba(140,51,207,1) 69%, rgba(140,51,207,1) 100%)",
    green: "#44A841",
    red: "#EA0402",
    orange: "#F9A956",
    blue: "#6CA5F1",
    violet: "rgba(140,51,207,1)",
  };

  const activeColor = themeColors[type] || themeColors.red;

  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState(`Bets cannot be placed in the last ${BET_CUTOFF} seconds.`);

  const [time, setTime] = useState(mainActiveTab?.id);
  useSocket(`color_prediction_timer_${mainActiveTab?.id}sec`, async (data) => {
    await setTime(data?.time);
  });

  const handleConfirm = async () => {

    if (time <= BET_CUTOFF) {
      setModalShow(true);
      setTimeout(() => {
        setModalShow(false);
      }, 1000);
      return;
    }
    if (!agreed) return;
    setBetError("");
    setIsLoading(true);



    try {
      const formData = new FormData();
      formData.append("play_time_id", mainActiveTab?.option_id);

      if (bet_type === "color")
        formData.append("color", selectedValue);

      if (bet_type === "number")
        formData.append("number", selectedValue);

      if (bet_type === "size")
        formData.append("size", selectedValue);

      formData.append("amount", totalAmount);

      const res = await dispatch(PlaceBet(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        setShowSuccess(true);
        setShowMessage(res?.payload?.data);
        setTimeout(() => {
          onClose();
          setShowSuccess(false);
        }, 1000);
        await dispatch(GetAllHistory())
        await dispatch(GETAuthLogin())
      } else {

        setShowSuccess(true);
        setShowMessage(res?.payload?.errors);
        setTimeout(() => {
          setShowSuccess(false);
        }, 1000);
        setBetError(res?.payload?.errors || "Bet failed. Try again.");
      }
    } catch (error) {
      console.error("Bet error:", error);
      setBetError("Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <section
        className="wingo-modal-wrapper"
        style={{ "--primary-color": activeColor }}
      >
        <div className="wingo-overlay" onClick={onClose}>
          <div className="wingo-container" onClick={(e) => e.stopPropagation()}>

            <div className="wingo-header">
              <h2 className="wingo-title">Win Go {mainActiveTab?.label}</h2>
              <div className="wingo-selection">Select {selectedValue}</div>
              <div className="wingo-arrow-down"></div>
            </div>

            <div className="wingo-body">

              {/* Balance */}
              <div className="wingo-row">
                <span className="wingo-label">Balance</span>
                <div className="wingo-btn-group">
                  {[1, 10, 100, 1000].map((v) => (
                    <button
                      key={v}
                      className={balance === v ? "active" : ""}
                      onClick={() => setBalance(v)}
                    >
                      {v}
                    </button>
                  ))}
                </div>
              </div>

              {/* Quantity */}
              <div className="wingo-row">
                <span className="wingo-label">Quantity</span>
                <div className="wingo-counter">
                  <button onClick={() => setQuantity(Math.max(1, quantity - 1))}>−</button>
                  <input type="text" value={quantity} readOnly />
                  <button onClick={() => setQuantity(quantity + 1)}>+</button>
                </div>
              </div>

              {/* Multipliers */}
              <div className="wingo-multipliers">
                {["1", "5", "10", "20", "50", "100"].map((m) => (
                  <button
                    key={m}
                    className={multiplier === m ? "active" : ""}
                    onClick={() => setMultiplier(m)}
                  >
                    X{m}
                  </button>
                ))}
              </div>

              {/* Agreement */}
              {/* <div className="wingo-agreement">
                <input
                  type="checkbox"
                  checked={agreed}
                  onChange={(e) => setAgreed(e.target.checked)}
                />
                <label>
                  I Agree <span className="wingo-link">« Pre-sale rules »</span>
                </label>
              </div> */}

              {/* Error */}
              {betError && (
                <small className="text-danger d-block mt-2 text-center">
                  {betError}
                </small>
              )}

            </div>

            <div className="wingo-footer">
              <button className="wingo-btn-cancel" onClick={onClose}>
                Cancel
              </button>
              <button
                className="wingo-btn-confirm"
                onClick={handleConfirm}
                disabled={!agreed || isLoading}
              >
                {isLoading ? "Placing..." : `Total Amount ₹${totalAmount}`}
              </button>
            </div>

          </div>
        </div>
      </section>

      <Successfull_strip_modal
        show={showSuccess}
        onHide={() => setShowSuccess(false)}
        textMsg={showMessage}
      />

      <Winner_Modal
        show={showWinner}
        onHide={() => { setShowWinner(false); onClose(); }}
      />

      <Looser_Modal
        show={showLooser}
        onHide={() => { setShowLooser(false); onClose(); }}
      />

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </>
  );
};

export default WinGoModal;